import type { ParsedMonthlyRateType } from "../../../../common-deprecated/types/FinanceInsuranceRateTypes";
import type {
    AceBusinessLeasingConfigCollectionType,
    ParsedAceBusinessLeasingConfigType,
} from "../../../shared-logic/ace/types";
import type { CalculationType } from "../../../shared-logic/types/FinanceTypes";
import {
    parseAceCarconfigCtaConfig,
    parseAceCarConfigBusinessLeasingInfo,
} from "../../../shared-logic/utils/formatters/formatBusinessLeasingInfo";

export const extractCalculatorFromFinanceRateFetch = (financeRate: ParsedMonthlyRateType): CalculationType => {
    const { quoteInfo = {} } = financeRate;

    return {
        financeQuoteId: quoteInfo.FINANCEQUOTEID.value,
        monthlyPayment: parseFloat(quoteInfo.MONTHLY_PAYMENT.value),
        mileage: parseFloat(quoteInfo.MILEAGE.value),
        duration: parseFloat(quoteInfo.DURATION.value),
        downpayment: 0,
        legalText: "",
    };
};

export const parseAceBusinessLeasingConfig = (
    aceConfig: AceBusinessLeasingConfigCollectionType,
    modelCode?: string,
): ParsedAceBusinessLeasingConfigType | undefined => {
    if (!aceConfig) return undefined;

    const config =
        (modelCode && aceConfig.models?.find((entry) => entry.model.toLowerCase() === modelCode.toLowerCase())) ||
        aceConfig.default;

    const ctas = parseAceCarconfigCtaConfig(config);
    const businessLeasingInfo = parseAceCarConfigBusinessLeasingInfo(config);

    return {
        businessLeasingInfo: businessLeasingInfo || undefined,
        summaryBasketCta: ctas || undefined,
    };
};
